import { createAxiosCancelable } from '@hmhco/core-network/src/axiosHelpers';
import requestHelper from '@hmhco/core-network/src/utils/requestHelper';
import { getIdentifiedPlatformConfig } from '@hmhco/login-config';

const forgotPasswordUrl = `/user/forgotPassword`;
const forgotPasswordUrlHnm = `/user/forgotPassword`;
const forgotPasswordUrlNwea = `/user/forgotPassword`;
const forgotPasswordUrlAitools = `/user/forgotPassword`;
const forgotPasswordUrlWritable = `/user/forgotPassword`;

export default (pactConfig = {}) => {
  const { client, cancel, cancelToken, isCancel } = createAxiosCancelable({
    includeAuth: false,
  });
  const request = requestHelper({
    client,
    cancelToken,
    isCancel,
    baseURL: getIdentifiedPlatformConfig().authorizationApi,
    pactConfig,
  });
  return {
    forgotPassword: ({ username, districtId }) =>
      request.post(
        forgotPasswordUrl,
        JSON.stringify({ username, districtId, platform: 'Ed' }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    cancel,
    forgotPasswordHnm: ({ username, districtId }) =>
      request.post(
        forgotPasswordUrlHnm,
        JSON.stringify({ username, districtId, platformId: 'flight' }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    forgotPasswordNwea: ({ username, districtId, orgRefId }) =>
      request.post(
        forgotPasswordUrlNwea,
        JSON.stringify({ username, districtId, orgRefId, platformId: 'nwea' }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    forgotPasswordAitools: ({ username, districtId }) =>
      request.post(
        forgotPasswordUrlAitools,
        JSON.stringify({
          username,
          districtId,
          platformId: 'Aitools',
        }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
    forgotPasswordWritable: ({ username, districtId, orgRefId }) =>
      request.post(
        forgotPasswordUrlWritable,
        JSON.stringify({
          username,
          districtId,
          orgRefId,
          platformId: 'writable',
        }),
        {
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        },
      ),
  };
};
